import { useMemo, useState } from "react";
import { latestResources } from "@/mocks/home";

export default function LatestResourcesSection() {
  const categories = useMemo(() => {
    const set = new Set(latestResources.map((item) => item.category));
    return ["全部", ...Array.from(set)];
  }, []);
  const [active, setActive] = useState("全部");

  const visible = useMemo(
    () =>
      active === "全部"
        ? latestResources
        : latestResources.filter((item) => item.category === active),
    [active],
  );

  return (
    <section id="latest" className="w-full border-b border-background-200/70 bg-background-50">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs font-medium uppercase tracking-[0.3em] text-primary-600">
              Latest Drops
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
              最新资源，按时间倒序排给你
            </h2>
            <p className="mt-3 max-w-xl font-body text-sm leading-7 text-foreground-600 md:text-base">
              每条一行，标题加一句摘要，扫一眼就知道是不是你要的那一类。
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            {categories.map((cat) => (
              <button
                key={cat}
                type="button"
                onClick={() => setActive(cat)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-3.5 py-1.5 font-label text-sm transition-colors ${
                  active === cat
                    ? "bg-primary-500 text-background-50"
                    : "border border-background-200 bg-background-100/70 text-foreground-600 hover:border-primary-200 hover:text-primary-600"
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 overflow-hidden rounded-2xl border border-background-200">
          {visible.map((item, index) => (
            <article
              key={item.id}
              className={`group flex cursor-pointer flex-col gap-3 px-5 py-5 transition-colors hover:bg-background-100/70 md:flex-row md:items-center md:gap-6 md:px-7 ${
                index !== 0 ? "border-t border-background-200/80" : ""
              }`}
            >
              <span className="hidden w-10 shrink-0 font-heading text-lg font-bold text-background-400 md:block">
                {String(index + 1).padStart(2, "0")}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
                    {item.title}
                  </h3>
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-xs text-secondary-900">
                    {item.category}
                  </span>
                </div>
                <p className="mt-1.5 font-body text-sm leading-7 text-foreground-600">
                  {item.summary}
                </p>
              </div>
              <div className="flex shrink-0 items-center justify-between gap-4 md:justify-end">
                <span className="flex items-center gap-1.5 font-label text-xs text-foreground-400">
                  <i className="ri-time-line text-sm"></i>
                  {item.time}
                </span>
                <span className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200 text-foreground-600 transition-colors group-hover:border-primary-300 group-hover:text-primary-600">
                  <i className="ri-arrow-right-up-line text-base"></i>
                </span>
              </div>
            </article>
          ))}
          {visible.length === 0 && (
            <div className="px-6 py-14 text-center font-body text-sm text-foreground-500">
              这个分类暂时没有新内容，换个分类看看吧。
            </div>
          )}
        </div>
      </div>
    </section>
  );
}